import React from 'react';
import './StreakPerfectHeadline.css';

/**
 * Streak celebration headline — straight text, Montserrat.
 * Mobile: two lines; desktop (768px+): single line.
 */
export default function StreakPerfectHeadline({
  line1 = 'PERFECT',
  line2 = 'STREAK!',
  singleLine = 'PERFECT STREAK!',
}) {
  return (
    <div className="streak-perfect-headline" aria-hidden="true">
      <div className="streak-perfect-headline-stacked">
        <span className="streak-perfect-headline-line streak-perfect-headline-line--top">{line1}</span>
        <span className="streak-perfect-headline-line streak-perfect-headline-line--bottom">{line2}</span>
      </div>
      <p className="streak-perfect-headline-single">{singleLine}</p>
    </div>
  );
}
